import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { transformCapacityManagementDrilldownData } from 'api/normalized/insightDrilldown/transformers';
import { RootState } from 'state/store';
import { CapacityManagementDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { JsonApiResource } from 'types/store/jsonApi';
import { CapacityManagementDrillDownApiResponse } from 'api/normalized/insightDrilldown/types';

/* ============================== STATE SETUP =============================== */
const insightDrilldownCapacityManagementAdapter =
  createEntityAdapter<CapacityManagementDrillDownItem>();

/* ================================= REDUCER ================================ */
const insightDrilldownCapacityManagementSlice = createSlice({
  name: 'normalized/insightDrilldownCapacityManagement',
  initialState: insightDrilldownCapacityManagementAdapter.getInitialState(),
  reducers: {
    addCapacityManagement: (
      state,
      action: PayloadAction<DrilldownJsonApiResponse['data']>
    ) => {
      const capacityManagementDrilldowns =
        transformCapacityManagementDrilldownData(
          action.payload as JsonApiResource<CapacityManagementDrillDownApiResponse>[]
        );
      insightDrilldownCapacityManagementAdapter.setMany(
        state,
        capacityManagementDrilldowns
      );
    },
  },
});

/* =============================== SELECTORS ================================ */
const defaultSelectors =
  insightDrilldownCapacityManagementAdapter.getSelectors<RootState>(
    (state) => state.normalized.insightDrilldownCapacityManagement
  );

const selectCapacityManagementByIds = (
  state: RootState,
  ids: string[]
): CapacityManagementDrillDownItem[] =>
  ids
    .map((id) => defaultSelectors.selectById(state, id))
    .filter((item) => !!item);

/* ================================ EXPORTS ================================= */
export const insightDrilldownCapacityManagementSelectors = {
  ...defaultSelectors,
  selectCapacityManagementByIds,
};
export const { addCapacityManagement } =
  insightDrilldownCapacityManagementSlice.actions;
export default insightDrilldownCapacityManagementSlice.reducer;
